import icon12 from '../images/service/icon/2.jpg'
import icon6 from '../images/service/icon/3.jpg'
import icon7 from '../images/service/icon/4.jpg'
import icon8 from '../images/service/icon/5.jpg'
import icon9 from '../images/service/icon/6.jpg'
import icon10 from '../images/service/icon/7.jpg'
import icon11 from '../images/service/icon/8.jpg'
import icon5 from '../images/service/icon/9.jpg'
import icon1 from '../images/service/icon/c1.jpg'
import icon2 from '../images/service/icon/c2.jpg'
import icon3 from '../images/service/icon/c3.jpg'
import icon4 from '../images/service/icon/c4.jpg'


const serviceHome = [
  {
    Id: '01',
    Icon: icon1,
    // SImg: sSimg1,
    title: 'Exploration and Production',
    Subtitle: 'Exploration and Production',
    slug: 'exploration-production',
    description:
      'Identifying and extracting oil and gas reserves through onshore and oˬshore drilling operations.',
  },
  {
    Id: '02',
    Icon: icon2,
    // SImg: sSimg2,
    title: 'Refining and Processing',
    Subtitle: 'Refining and Processing',
    slug: 'Refining-Processing',
    description:
      'Advanced facilities for refining crude oil and processing gas',
  },
  {
    Id: '03',
    Icon: icon3,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '04',
    Icon: icon4,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '05',
    Icon: icon5,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '06',
    Icon: icon6,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '07',
    Icon: icon7,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '08',
    Icon: icon8,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '09',
    Icon: icon9,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '10',
    Icon: icon10,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '11',
    Icon: icon11,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '12',
    Icon: icon12,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
]

export default serviceHome
